<script>
import router from "../router";

export default {
  data() {
    return {
      name: "",
      ruleForm: {
        uname: "",
        password: "",
      },
    };
  },
  mounted() {
    localStorage.removeItem("token")
    localStorage.removeItem("name")
    localStorage.removeItem('uname')
    clearInterval(this.timer);
    this.$axios.get("/active").then((res) => {
      if (res.data.code == 503) {
        this.$confirm('服务器维护中，请稍后再试', {
          confirmButtonText: "刷新",
          type: "error",
          showCancelButton: false,
          showClose: false,
        }).then((r) => {
          location.reload()
        })
      } else {
        this.name = res.data.message
      }
    })
  },
  methods: {
    submitForm() {
      this.$axios.get("/admin/login", {
        params: {
          username: this.ruleForm.uname,
          password: this.ruleForm.password
        }
      }).then((response) => {
        if (response.data.code == 301) {
          this.$message.error('用户不存在或密码错误')
        } else {
          localStorage.setItem('token', response.data.message)
          localStorage.setItem('jurisdiction', response.data.data.jurisdiction)
          localStorage.setItem('name', response.data.data.name)
          localStorage.setItem('title', this.name)
          // 存第一份点击的时间
          sessionStorage.setItem("lastClickTime", new Date().getTime());
          router.push({name: 'home'});
        }
      })
    },
  },
};
</script>
<template>
  <div class="main">
    <img src="../assets/背景.png">
    <h1 class="t">{{ name }}小程序后台管理系统</h1>
    <el-card class="box-card">
      <h2>登录</h2>
      <el-form
        :data="ruleForm"
        ref="ruleForm"
        label-position="left"
        label-width="70px"
        class="login-from"
      >
        <el-form-item label="用户名" prop="uname">
          <el-input v-model="ruleForm.uname" @keyup.enter.native="submitForm"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            @keyup.enter.native="submitForm"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btnGroup">
        <el-button type="primary" style="width: 200px;" size="large" @click="submitForm()">登录</el-button>
      </div>
    </el-card>
  </div>
</template>
<style scoped>
.main:before {
  content: '';
  display: table;
}

.t {
 text-align: center;  margin: 80px auto;
}

img {
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
}

.box-card {
  margin: 100px auto;
  width: 400px;
}

.login-from {
  margin: auto auto;
}

.btnGroup {
  width: 200px;
  margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/loginView.vue